<template>
  <div>
    <div class="py-3"></div>
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark>
        <v-toolbar-title>하우스 애드 · 참여정보</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <!-- 검색 -->
      <v-card-text class="pb-0">
        <v-row dense align="center">
          <v-col cols="12" sm="3">
            <v-select
              v-model="searchType"
              :items="searchTypeOptions"
              label="검색 타입"
              outlined dense hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field
              v-model="searchKeyword"
              label="검색어"
              outlined dense hide-details
              prepend-inner-icon="mdi-magnify"
              @keyup.enter="onSearch"
              clearable
              :placeholder="searchType === 'USER_ID' ? '유저 아이디' : 'ADID'"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" depressed block @click="onSearch" :loading="loading">
              <v-icon left>mdi-magnify</v-icon>검색
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn outlined block @click="loadAll" :loading="loading">
              전체 조회
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- 리스트 -->
      <v-card-text class="pa-0 pt-2">
        <div style="overflow-x: auto;">
        <v-data-table
          :headers="headers"
          :items="participationList"
          :items-per-page="20"
          :footer-props="{'items-per-page-options':[20, 50, 100]}"
          :loading="loading"
          class="elevation-0"
        >
          <template v-slot:item.AD_CONFIG_PID="{ item }">
            <span class="font-weight-medium">{{ item.AD_APP_NAME || getAdName(item.AD_CONFIG_PID) }}</span>
            <span class="text-caption grey--text ml-1">(#{{ item.AD_CONFIG_PID }})</span>
          </template>
          <template v-slot:item.CALLER_APP_PID="{ item }">
            <span class="font-weight-medium">{{ item.CALLER_APP_NAME || getAppName(item.CALLER_APP_PID) }}</span>
            <span class="text-caption grey--text ml-1">(#{{ item.CALLER_APP_PID }})</span>
          </template>
          <template v-slot:item.AD_TYPE="{ item }">
            <v-chip small :color="item.AD_TYPE === 'install' ? 'blue' : 'purple'" dark>
              {{ item.AD_TYPE === 'install' ? '설치' : '실행' }}
            </v-chip>
          </template>
          <template v-slot:item.COMPLETED_AT="{ item }">
            <span v-if="item.COMPLETED_AT" class="text-caption green--text">{{ item.COMPLETED_AT }}</span>
            <span v-else class="text-caption grey--text">미완료</span>
          </template>
          <template v-slot:item.REWARD_PAID_AT="{ item }">
            <span v-if="item.REWARD_PAID_AT" class="text-caption blue--text">{{ item.REWARD_PAID_AT }}</span>
            <span v-else class="text-caption grey--text">미지급</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon small color="red" @click="deleteParticipation(item)" title="삭제">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        </div>
        <v-container v-if="!loading && participationList.length === 0" class="text-center py-8">
          <v-icon size="56" color="grey lighten-1">mdi-account-search</v-icon>
          <p class="text-body-1 grey--text mt-3">유저 아이디 또는 ADID로 검색하세요.</p>
        </v-container>
      </v-card-text>
    </v-card>

    <div class="py-12"></div>
    <div class="py-12"></div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: 'HouseAd_Participation',
  data: () => ({
    loading: false,
    searchType: 'USER_ID',
    searchKeyword: '',
    participationList: [],
    searchTypeOptions: [
      { text: '유저 아이디', value: 'USER_ID' },
      { text: 'ADID', value: 'ADID' },
    ],
    headers: [
      { text: 'PID', value: 'PID', width: '70px' },
      { text: '광고명', value: 'AD_CONFIG_PID', width: '140px' },
      { text: '요청 앱', value: 'CALLER_APP_PID', width: '140px' },
      { text: '타입', value: 'AD_TYPE', width: '80px' },
      { text: '유저 아이디', value: 'USER_ID', width: '130px' },
      { text: 'ADID', value: 'ADID', width: '160px' },
      { text: '요청일시', value: 'REQUESTED_AT', width: '150px' },
      { text: '완료일시', value: 'COMPLETED_AT', width: '130px' },
      { text: '보상 지급', value: 'REWARD_PAID_AT', width: '130px' },
      { text: '삭제', value: 'actions', width: '60px', sortable: false },
    ],
  }),
  computed: {
    ...mapState(['housead_app_list', 'housead_ad_configs']),
    appMap() {
      const map = {};
      (this.housead_app_list || []).forEach(a => { map[a.id] = a.appName || ''; });
      return map;
    },
    adMap() {
      // 광고 설정의 appId로 앱 이름 매핑
      const map = {};
      (this.housead_ad_configs || []).forEach(c => {
        map[c.appId] = this.appMap[c.appId] || `광고#${c.appId}`;
      });
      return map;
    },
  },
  created() {
    this.loadMasterData();
  },
  methods: {
    ...mapActions([
      'HOUSEAD_FETCH_CMS_INIT',
      'HOUSEAD_GET_PARTICIPATION_LIST',
      'HOUSEAD_SEARCH_PARTICIPATION',
      'HOUSEAD_DELETE_PARTICIPATION',
    ]),
    async loadMasterData() {
      try {
        await this.HOUSEAD_FETCH_CMS_INIT();
      } catch (err) {
        console.error('마스터 데이터 로드 실패:', err);
      }
    },
    getAppName(pid) {
      return this.appMap[pid] || `앱#${pid}`;
    },
    getAdName(pid) {
      return this.adMap[pid] || `광고#${pid}`;
    },
    async loadAll() {
      this.loading = true;
      try {
        const body_data = await this.HOUSEAD_GET_PARTICIPATION_LIST();
        this.participationList = body_data.participation_list || body_data || [];
      } catch (err) {
        console.error('참여정보 로드 실패:', err);
      } finally {
        this.loading = false;
      }
    },
    async onSearch() {
      if (!this.searchKeyword) {
        alert('검색어를 입력해주세요.');
        return;
      }
      this.loading = true;
      try {
        const body_data = await this.HOUSEAD_SEARCH_PARTICIPATION({
          search_type: this.searchType,
          keyword: this.searchKeyword,
        });
        this.participationList = body_data.participation_list || body_data || [];
      } catch (err) {
        console.error('참여정보 검색 실패:', err);
      } finally {
        this.loading = false;
      }
    },
    async deleteParticipation(item) {
      if (!confirm(`PID [${item.PID}] 참여정보를 삭제하시겠습니까?`)) return;
      try {
        await this.HOUSEAD_DELETE_PARTICIPATION({ pid: item.PID });
        this.participationList = this.participationList.filter(p => p.PID !== item.PID);
      } catch (err) {
        console.error(err);
        alert('삭제에 실패했습니다.');
      }
    },
  },
};
</script>
